import {
  useMutation,
  useQueryClient,
} from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { interpolate } from "@/helpers"
import { destructuringPhone } from "@/utils/string-helper"
interface UseChangeCustomerProps {
  customerId: string
  email: string
  mobilePhone: string
}
const useChangeCustomer = (customerId: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({
      customerId,
      email,
      mobilePhone,
    }: UseChangeCustomerProps) => {
      const url = interpolate(ENDPOINTS.CUSTOMER_BY_ID, {
        customerId,
      })
      const { countryCode, areaCode, number } =
        destructuringPhone(mobilePhone)
      const body = {
        email,
        phone: {
          countryCode,
          areaCode,
          number,
        },
      }
      await api.put(url, body)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ENDPOINTS.CUSTOMER_BY_ID, customerId],
      })
    },
  })
}
export default useChangeCustomer
